import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ein' })
export class EinPipe implements PipeTransform {
    private _pattern = /^(\d{2})(\d{7})$/;

    public transform(value: any) {
        var match = this._pattern.exec(value);

        if (match) {
            return match[1] + '-' + match[2];
        }

        return value;
    }
}
